import { createFileRoute, redirect } from "@tanstack/react-router";

import { BlastroConnectPage } from "@/features/Blastro/BlastroConnectPage";
import {
  blastroConnectPath,
  captureBlastroLinkFragment,
} from "@/features/Blastro/installationLink";

export const Route = createFileRoute("/blastro/$siteId/connect")({
  beforeLoad: ({ context, params, location }) => {
    captureBlastroLinkFragment();
    // The router may have cached the original URL before main stripped it.
    if (location.hash) {
      throw redirect({
        to: "/blastro/$siteId/connect",
        params: { siteId: params.siteId },
        hash: "",
        replace: true,
      });
    }
    if (!context.auth?.isAuthenticated) {
      // A proof must never become part of the login redirect's query string.
      throw redirect({
        to: "/login",
        search: { redirect: blastroConnectPath(params.siteId) },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  return <BlastroConnectPage key={siteId} siteId={siteId} />;
}
